module.exports = __webpack_public_path__ + "media/images/pinrigh-7a5d59f0955096349e7dcdf3368ef900.png";